import { render, staticRenderFns } from "./DocumentExportChoices.vue?vue&type=template&id=757a3253&scoped=true&"
import script from "./DocumentExportChoices.vue?vue&type=script&lang=js&"
export * from "./DocumentExportChoices.vue?vue&type=script&lang=js&"
import style0 from "./DocumentExportChoices.vue?vue&type=style&index=0&id=757a3253&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757a3253",
  null
  
)

export default component.exports